export interface ThePodVersusOtherSleepAidsProps {}

export enum TableCheckType {
	NONE = 'none',
	CHECK = 'check',
	HIGHLIGHT = 'highlight',
}

export interface TableItem {
	title: string
	checks: TableCheckType[]
}
